import { useState } from "react";
import { useCart } from "../context/CartContext";

const CartDrawer = () => {
  const { items, subtotalUSD, updateQty, removeItem, isOpen, setIsOpen } = useCart();
  const [isCheckingOut, setIsCheckingOut] = useState(false);
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const handleCheckout = async () => {
    setError("");
    setIsCheckingOut(true);
    try {
      const res = await fetch("/api/create-checkout-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: items.map((i) => ({
            id: i.productId,
            size: i.size,
            qty: i.qty,
          })),
        }),
      });
      let data;
      try {
        data = await res.json();
      } catch {
        throw new Error(`Checkout is temporarily unavailable (error ${res.status}). Please try again.`);
      }
      if (!res.ok || !data.url) {
        throw new Error(data.error || "Could not start checkout");
      }
      window.location.href = data.url;
    } catch (e) {
      setError(e.message);
      setIsCheckingOut(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div
        className="absolute inset-0 bg-black/60"
        onClick={() => setIsOpen(false)}
      />
      <div className="relative w-full max-w-sm bg-coolLight text-coolInk h-full p-6 overflow-y-auto font-monda flex flex-col">
        <div className="flex justify-between items-center mb-6">
          <p className="text-2xl font-bold">Cart</p>
          <button onClick={() => setIsOpen(false)} className="text-2xl leading-none">
            &times;
          </button>
        </div>

        {items.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          <div className="flex flex-col gap-4 flex-1">
            {items.map((item) => (
              <div
                key={`${item.productId}::${item.size || ""}`}
                className="flex justify-between items-start border-b border-coolInk/10 pb-3"
              >
                <div>
                  <p className="font-semibold">{item.product.name}</p>
                  {item.size && <p className="text-sm">Size: {item.size}</p>}
                  <p className="text-sm">${item.product.priceUSD.toFixed(2)} each</p>
                  <div className="flex items-center gap-2 mt-1">
                    <button
                      className="w-6 h-6 border border-coolInk rounded"
                      onClick={() =>
                        updateQty(item.productId, item.size, item.qty - 1)
                      }
                    >
                      -
                    </button>
                    <span>{item.qty}</span>
                    <button
                      className="w-6 h-6 border border-coolInk rounded"
                      onClick={() =>
                        updateQty(item.productId, item.size, item.qty + 1)
                      }
                    >
                      +
                    </button>
                  </div>
                </div>
                <button
                  className="text-sm underline"
                  onClick={() => removeItem(item.productId, item.size)}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="mt-6">
          <div className="flex justify-between font-semibold mb-2">
            <span>Subtotal</span>
            <span>${subtotalUSD.toFixed(2)}</span>
          </div>
          <p className="text-xs mb-3">
            Shipping and final total calculated at checkout.
          </p>
          {error && <p className="text-sm text-red-700 mb-2">{error}</p>}
          <button
            disabled={items.length === 0 || isCheckingOut}
            onClick={handleCheckout}
            className="w-full bg-coolDark text-coolPaper p-3 disabled:opacity-40 hover:bg-rust transition-colors"
          >
            {isCheckingOut ? "Redirecting to checkout..." : "Checkout"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartDrawer;
